var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "white",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1991 11.1437H17.8565C17.8565 10.4316 17.5736 9.7486 17.07 9.24503C16.5664 8.74146 15.8835 8.45856 15.1713 8.45856C14.4591 8.45856 13.7762 8.74146 13.2726 9.24503C12.769 9.7486 12.4861 10.4316 12.4861 11.1437V13.1576H18.5278C19.0619 13.1576 19.5741 13.3698 19.9518 13.7475C20.3295 14.1252 20.5417 14.6374 20.5417 15.1715V19.1993C20.5417 19.7334 20.3295 20.2457 19.9518 20.6233C19.5741 21.001 19.0619 21.2132 18.5278 21.2132H10.4722C9.93811 21.2132 9.42587 21.001 9.04819 20.6233C8.67051 20.2457 8.45834 19.7334 8.45834 19.1993V15.1715C8.45834 14.6374 8.67051 14.1252 9.04819 13.7475C9.42587 13.3698 9.93811 13.1576 10.4722 13.1576H11.1435V11.1437C11.1435 10.0755 11.5679 9.05103 12.3232 8.29568C13.0786 7.54032 14.1031 7.11597 15.1713 7.11597C16.2395 7.11597 17.264 7.54032 18.0194 8.29568C18.7747 9.05103 19.1991 10.0755 19.1991 11.1437ZM18.5278 14.5002H10.4722C10.2942 14.5002 10.1234 14.571 9.99755 14.6968C9.87165 14.8227 9.80093 14.9935 9.80093 15.1715V19.1993C9.80093 19.3773 9.87165 19.5481 9.99755 19.674C10.1234 19.7999 10.2942 19.8706 10.4722 19.8706H18.5278C18.7058 19.8706 18.8766 19.7999 19.0025 19.674C19.1284 19.5481 19.1991 19.3773 19.1991 19.1993V15.1715C19.1991 14.9935 19.1284 14.8227 19.0025 14.6968C18.8766 14.571 18.7058 14.5002 18.5278 14.5002Z",
    fill: "white",
    fillOpacity: 0.95
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.14f1cb06.svg";
export { ForwardRef as ReactComponent };